import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useGetEventAccountQuery } from '../../../graphql/queries/getEventAccount.generated';
import ClassicLoadingSpinner from '../../../components/LoadingSpinner/ClassicLoadingSpinner';
import i18n from '@/utils/i18n';
import EventCard from '../components/EventCard';

export const EventAccountHomePage = () => {
  const { eventAccountId } = useParams<{
    eventAccountId: string;
  }>();

  const { data, loading } = useGetEventAccountQuery({
    errorPolicy: 'all',
    variables: {
      id: eventAccountId,
    },
  });

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <ClassicLoadingSpinner />
      </div>
    );
  }

  const events = data?.eventAccount?.participating_in_events;

  return (
    <div>
      <h1 className="mt-2 mb-2">
        {i18n.t('EventAccountEventsList:eventsFor', {
          eventAccountName: data?.eventAccount?.name,
        })}
      </h1>

      {/* Events */}
      <div className="d-flex justify-content-between flex-wrap gap-4">
        {events?.map((event) => (
          <EventCard key={`event_card_${event.id}`} event={event}>
            <Link
              id={`view-details-button_${event.id}`}
              to={`/events-dashboard-event/${eventAccountId}/${event.id}/inventory`}
              className="btn btn-primary"
            >
              {i18n.t('EventsDashboard:viewDetails')}
            </Link>
          </EventCard>
        ))}
      </div>
    </div>
  );
};
